import "./bootstrap";
import "../css/app.css";

import { createApp, DefineComponent, h } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";

import { createPinia } from "pinia";
export const pinia = createPinia();

import vClickOutside from "click-outside-vue3";
import "vue-universal-modal/dist/index.css";
import VueUniversalModal from "vue-universal-modal";
import VueSocialSharing from "vue-social-sharing";

// import '../css/app.css';

import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { ZiggyVue } from "ziggy-js";

const appName = import.meta.env.APP_NAME || "Timbre Podcasts";

createInertiaApp({
	title: (title) => (title ? `${title} - ${appName}` : appName),
	resolve: (name) => resolvePageComponent(`./pages/${name}.vue`, import.meta.glob<DefineComponent>("./pages/**/*.vue")),
	setup({ el, App, props, plugin }) {
		createApp({ render: () => h(App, props) })
			.use(plugin)
			.use(ZiggyVue)
			.provide("is_mobile", window.screen.width <= 640)
			.use(pinia)
			.use(VueUniversalModal, {
				teleportTarget: "#modals",
				modalComponent: "u-modal",
			})
			.use(vClickOutside)
			.use(VueSocialSharing)
			.mount(el);
	},
	progress: {
		color: "#4B5563",
	},
});
